import {Component} from '@angular/core';
import {MatBottomSheet} from '@angular/material/bottom-sheet';
import {Destroyable} from "../destroyable/destroyable.component";

@Component({
  template: ''
})
export abstract class ClosableBottomSheetComponent extends Destroyable {

  protected constructor(private bottomSheet: MatBottomSheet) {
    super();
  }

  protected close(data?: any): void {
    this.bottomSheet.dismiss(data);
  }

}
